// src/pages/CompleteRegisterPage.jsx
import React, { useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { IoHomeOutline } from "react-icons/io5";

import { useCompleteRegistrationMutation } from "../context/authApi"; // ❗ shu faylni biroz pastda yozaman
import { setAuthData } from "../utils/auth";

const PASSWORD_RULE = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

export default function CompleteRegisterPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const phone = location.state?.phone; // register-phone dan kelgan raqam

  const [completeRegistration, { isLoading }] =
    useCompleteRegistrationMutation();

  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone) {
      setError("Telefon raqami topilmadi. Qaytadan ro‘yxatdan boshlang.");
      return;
    }

    if (!PASSWORD_RULE.test(password)) {
      setError(
        "Parol talablarga mos emas. Kamida 8 ta belgi, katta-kichik harf va raqam bo‘lishi kerak."
      );
      return;
    }

    try {
      setError("");

      const res = await completeRegistration({
        phone,
        password,
        name: name || null,
        email: email || null,
      }).unwrap();

      // { message, token, user } qaytadi
      setAuthData({
        token: res.token,
        user: res.user,
      });

      navigate("/dashboard");
    } catch (err) {
      console.error("complete-registration error", err);
      setError(err?.data?.message || "Server xatosi");
    }
  };

  return (
    <div className="min-h-screen flex flex-col pt-12 pb-8 sm:pt-16 sm:pb-12 md:pt-20 md:pb-16  lg:pt-24 lg:pb-20 xl:pt-28 xl:pb-24 ">
      {/* Logo */}
      <div className="pt-8 flex justify-center">
        <div className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white font-semibold text-lg">
            L
          </div>
          <span className="text-lg font-semibold text-gray-900">
            LiveQuiz.uz
          </span>
        </div>
      </div>

      <div className="flex-1 flex items-start justify-center mt-4 px-4 pb-10">
        <div className="w-full max-w-md bg-white rounded-2xl  shadow-lg border border-gray-100 px-8 py-8 sm:px-10 sm:py-10">
          {/* Bosh sahifa link */}
          <div className="flex justify-end mb-4 text-xs text-gray-500">
            <Link
              to="/"
              className="flex items-center gap-1 hover:text-gray-800"
            >
              <IoHomeOutline className="text-base" />
              Bosh sahifa
            </Link>
          </div>

          {/* Title */}
          <div className="text-center mb-6">
            <h1 className="text-[22px] sm:text-[24px] font-semibold text-gray-900">
              Ro&apos;yxatdan o&apos;tishni yakunlang
            </h1>
            <p className="mt-2 text-xs sm:text-[13px] text-gray-500">
              Parol yarating va profilingizni to&apos;ldiring
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Parol */}
            <div>
              <label className="block text-xs font-medium text-gray-800 mb-1.5">
                Parol <span className="text-red-500">*</span>
              </label>
              <div
                className={
                  "flex items-center rounded-lg border px-3 py-1 bg-gray-50 " +
                  (error ? "border-red-400" : "border-gray-200")
                }
              >
                <input
                  type={showPass ? "text" : "password"}
                  placeholder="Parolni kiriting"
                  className="flex-1 bg-transparent text-sm border-none outline-none"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setError("");
                  }}
                />
                <button
                  type="button"
                  onClick={() => setShowPass((s) => !s)}
                  className="text-gray-500 text-xs"
                >
                  {showPass ? (
                    <FiEyeOff className="w-4 h-4" />
                  ) : (
                    <FiEye className="w-4 h-4" />
                  )}
                </button>
              </div>
            </div>

            {/* Ism (ixtiyoriy) */}
            <div>
              <label className="block text-xs font-medium text-gray-800 mb-1.5">
                Ism (ixtiyoriy)
              </label>
              <input
                type="text"
                placeholder="Sizning ismingiz"
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm outline-none focus:bg-white focus:border-black focus:ring-1 focus:ring-black"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            {/* Email (ixtiyoriy) */}
            <div>
              <label className="block text-xs font-medium text-gray-800 mb-1.5">
                Email (ixtiyoriy)
              </label>
              <input
                type="email"
                placeholder="your@email.com"
                className="w-full rounded-lg border border-gray-200 bg-gray-50 px-3 py-2.5 text-sm outline-none focus:bg-white focus:border-black focus:ring-1 focus:ring-black"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>

            {/* Xato xabar */}
            {error && (
              <p className="text-[11px] text-red-500 leading-snug">{error}</p>
            )}

            {/* Tugma */}
            <div className="pt-2">
              <button
                type="submit"
                disabled={isLoading}
                className="w-full rounded-lg bg-gray-700 text-white text-sm font-medium py-2.5 hover:bg-gray-800 transition disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {isLoading
                  ? "Yakunlanmoqda..."
                  : "Ro‘yxatdan o‘tishni yakunlash"}
              </button>
            </div>
          </form>

          {/* Parol talablari */}
          <div className="mt-5">
            <p className="text-xs font-medium text-gray-700 mb-2">
              Parol talablari:
            </p>
            <ul className="text-xs text-gray-500 list-disc list-inside space-y-1">
              <li>Kamida 8 ta belgi</li>
              <li>Kichik harflar (a-z)</li>
              <li>Katta harflar (A-Z)</li>
              <li>Raqamlar (0-9)</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="pb-6 text-center text-[11px] text-gray-400">
        © {new Date().getFullYear()} LiveQuiz.uz. Barcha huquqlar
        himoyalangan.
      </div>
    </div>
  );
}
